// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___KfE_Y","translateIcon":"styles-module__translateIcon___txcK3","translatedText":"styles-module__translatedText___1zj_j"};